import { AritoFormV2, GetDocumentsV2 as GetDocumentsInvoice } from '@/components/custom/erp';
import { getHoaDonMuaHangTrongNuocInvalidMessage } from './validation-message';
import type { FormDialogProps } from './types';
import ConfirmDialog from '../ConfirmDialog';
import { FormHeader } from './FormHeader';
import { useFormDialog } from './hooks';
import { FormTabs } from './FormTabs';
import BottomBar from './BottomBar';

const FormDialog = (props: FormDialogProps) => {
  const dialog = useFormDialog(props);
  const { so_luong, chi_phi, thue, tong_thanh_toan, tong_tien, chiet_khau } = dialog.totals;

  return (
    <>
      <AritoFormV2
        mode={dialog.formMode}
        initialData={dialog.initialValues}
        title={dialog.title}
        schema={dialog.schema}
        actionButtons={dialog.actionButtons}
        subTitle='Hóa đơn mua hàng trong nước'
        onSubmit={dialog.submit}
        onClose={dialog.onClose}
        getInvalidSubmitMessage={getHoaDonMuaHangTrongNuocInvalidMessage}
        headerFields={<FormHeader dialog={dialog} />}
        tabs={FormTabs(dialog)}
        bottomBar={
          dialog.activeTab === 'info' ? (
            <BottomBar
              so_luong={so_luong}
              chi_phi={chi_phi}
              thue={thue}
              tong_thanh_toan={tong_thanh_toan}
              tong_tien={tong_tien}
              chiet_khau={chiet_khau}
              state={dialog.formState.state}
            />
          ) : null
        }
      />

      {dialog.taxConfirm.open ? (
        <ConfirmDialog
          open={dialog.taxConfirm.open}
          onClose={dialog.taxConfirm.close}
          onConfirm={dialog.taxConfirm.confirm}
          title='Hỏi'
          content='Bạn có muốn phân bổ lại tiền thuế cho các mặt hàng ở chi tiết không?'
        />
      ) : null}

      {dialog.documents.open ? (
        <GetDocumentsInvoice
          onSearch={dialog.documents.selection}
          onClose={dialog.documents.close}
          chungTuType='DHMTN'
          detailColumns={dialog.documents.columns}
        />
      ) : null}
    </>
  );
};

export default FormDialog;
